export default "__VITE_ASSET__6cac68eb__"